module.exports = __webpack_public_path__ + "static/media/andressa-queiroz.8347f700.jpeg";